import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { faqItems } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream-100 py-14 sm:py-20" data-id="element-128" data-mp="1bmd6p6zvac52">
      <div className="mx-auto w-full max-w-2xl px-4 sm:px-6" data-id="element-129" data-mp="1gkn3tn55jmtb">
        <h2 className="text-center font-display text-[26px] font-bold leading-[1.15] text-navy-900 sm:text-4xl" data-id="element-130" data-mp="2496ajy8jzrja">
          ❓ Frequently asked{' '}
          <em className="not-italic text-gold-600" data-id="element-131" data-mp="289hvzd8qpvvt">questions</em>
        </h2>

        <div className="mt-8 space-y-2.5" data-id="element-132" data-mp="1uk6cch1vl065">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.question} className="overflow-hidden rounded-2xl border border-navy-900/10 bg-white shadow-card" data-id="element-133" data-mp="1zg4sxigypdw0" data-mpi={index}>
                <h3 data-id="element-134" data-mp="2s0buaohm73yv">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-cream-100 sm:px-5" data-id="element-135" data-mp="2s0lj48qxb52z">
                    <span className="text-[14.5px] font-bold leading-snug text-navy-900 sm:text-[15.5px]" data-id="element-136" data-mp="1oj185cbfsquh">
                      {item.question}
                    </span>
                    <ChevronDownIcon className={`h-4.5 w-4.5 shrink-0 text-gold-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-137" data-mp="1jmaramrt5r80" />
                  </button>
                </h3>
                {isOpen ? <div id={`faq-panel-${index}`} className="border-t border-navy-900/10 px-4 py-4 sm:px-5" data-id="element-138" data-mp="3udjbnsud6g9w">
                    <p className="text-[14px] leading-relaxed text-navy-700/85" data-id="element-139" data-mp="237o7bm767zkj">
                      {item.answer}
                    </p>
                  </div> : null}
              </div>;
        })}
        </div>

        <div className="mx-auto mt-8 w-full max-w-md" data-id="element-140" data-mp="2cafjxpbs91dr">
          <CTAButton label="I’m ready — get access now" subline="Instant access · One-time payment of $27 USD · 7-day guarantee" data-id="element-141" data-mp="2h8h7amg8rmv1" />
        </div>
      </div>
    </section>;
}